import React from "react";
import logo from "../../images/wdc-logo.png";

export default function Welcome() {
  return (
    <div className="flex flex-col items-center px-2 py-6 text-center">
      <img
        src={logo}
        alt="Web Design Collective"
        className="mb-8 h-12 w-auto sm:h-14"
      />
      <p className="max-w-lg text-2xl font-medium italic leading-relaxed text-wdc-black">
        “Design is the silent ambassador of your brand.”
      </p>
      <span className="mt-3 text-base font-semibold uppercase tracking-[0.16em] text-wdc-orange-deep">
        — Paul Rand
      </span>
      <p className="mt-8 max-w-md text-base leading-relaxed text-wdc-charcoal/80">
        We'll ask about your business, your audience, this project and your
        design preferences — grouped into a few short sections. It only takes a
        few minutes. Let's begin.
      </p>
    </div>
  );
}
